<!--
// app/components/layout/header/ButtonsNavbar.vue
-->
<script setup lang="ts">
import ButtonLive from "~/components/layout/header/featured-buttons/ButtonLive.vue";
import ButtonTickets from "~/components/layout/header/featured-buttons/ButtonTickets.vue";
import ButtonStore from "~/components/layout/header/featured-buttons/ButtonStore.vue";
</script>

<template>
  <!--  live button-->
  <button-live></button-live>

  <!--  tickets button-->
  <button-tickets></button-tickets>

  <!--  store button-->
  <button-store></button-store>
</template>

<style scoped></style>
